// 权限控制指令
export const vPermission = {
  mounted(el, binding) {
    const { value, modifiers } = binding
    const hasPermission = checkPermission(value)

    if (!hasPermission) {
      if (modifiers.disable) {
        el.disabled = true
        el.style.cursor = 'not-allowed'
      } else {
        el.parentNode?.removeChild(el)
      }
    }
  }
}

// 检查权限的函数
function checkPermission(permission) {
  // 从 localStorage 中获取用户权限
  const userPermissions = getUserPermissions()
  return userPermissions.includes(permission)
}

// 获取用户权限的函数
function getUserPermissions() {
  return JSON.parse(localStorage.getItem('permissions') || '[]')
}

// 导出插件
export default {
  install(app) {
    app.directive('permission', vPermission)
  }
}
